import { HYBRID_STORES_OFFER_MODAL_VIEW } from './types';

export const triggerHybridStoresOfferOverlayIsViewed = (merchantName) => ({
  type: HYBRID_STORES_OFFER_MODAL_VIEW,
  merchantName,
});
